// src/components/common/Toast/Toast.jsx

import React, { useEffect } from 'react';
import styles from './Toast.module.css';
import { FiCheck, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';
import { FaExclamationTriangle } from 'react-icons/fa';

const Toast = ({ message, type = 'success', onClose, duration = 5000 }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <FiCheck size={18} />;
            case 'error':
                return <FiAlertCircle size={18} />;
            case 'warning':
                return <FaExclamationTriangle size={18} />;
            default:
                return <FiInfo size={18} />;
        }
    };

    const getTypeClass = () => {
        switch (type) {
            case 'success':
                return styles.toastSuccess;
            case 'error':
                return styles.toastError;
            case 'warning':
                return styles.toastWarning;
            default:
                return styles.toastInfo;
        }
    };

    return (
        <div className={`${styles.toast} ${getTypeClass()}`}>
            <span className={styles.toastIcon}>{getIcon()}</span>
            <span className={styles.toastMessage}>{message}</span>
            <button onClick={onClose} className={styles.toastClose}>
                <FiX size={16} />
            </button>
        </div>
    );
};

export default Toast;